import { getAssetPath, h } from '@stencil/core';
import omit from 'lodash/omit';
import { EApcButtonType, myProductsResponseStatus, ONLINE_VIEW, PDP_SOFTWARE, CircularProductTypes, RANGE, VIEW_ONLINE, STATUS_TYPES, PageNames, gaLocationNames, pesCatalogPageTypes, virtualPagesNames, addToCartMainEvent, ApigeeCircularStockAvailability, buyOnlineVirtualPageEvent, buyOnlineCircularVirtualPageEvent, documentDownloadEvent, getConsumerSpecificData, getSlottedContent, indexDBBreadcrumbs, isAnalyticsEnabled, isIndexDBEnabled, isV3, onlineSoftwareModalClickEvent, removeFromFavoritesEvent, send, store, setLinearProductData, setActiveProductTab, setError, ACTION_TYPES, viewItemListEvent, capitalizeFirstLetter, selectItemCTAEvent, allFinished, tryParse, ConfiguratorHandler, exitToSchneiderEvent, triggerCtaClickEvent, viewItemGA4Event, } from '@pes-ui/utils';
import merge from 'lodash/merge';
import { cloneDeep, isEmpty } from 'lodash';
import { isBrowser } from '../../../globals/utils';
import { getCommerceConnectorSettings, getProductsDataFeed } from '../../commerce-connector/services/main';
import { getIsCustomAddToFavoritesEnabled, getIsProductsInCustomFavorites, isAppRoutingEnabled, } from '../../pes-router/utils';
import NotificationBannerController from '../../UI/pes-notification-banner/controller';
import { getApcCta, getAvailabilityInfo } from '../../../globals/apc-cta/api';
import { routeToShopSeUtils, updateBuyOnlineButtonLabel } from '../../../globals/cta-shoppable/utils';
import { addToCart, addToFavorites, availabilityUrl, createAccountUrl, formCtaUrl, myAccountListUrl, removeFromFavorites, signInUrl, } from '../../../globals/apc-cta/utils';
import { MAX_PDP_WIDTH } from '../constants';
import { getProductSoftware } from '../../../globals/software-documents/api';
import { additionalInfoData, isViewOnline } from '../../../globals/software-documents/utils';
import { fetchProductData, formatPrice, gatherDataForViewItemAnalyticsEvent, setProductSelectorAvailability, softwareDocumentsToSoftwareInfo, } from '../utils';
import { getMyProductsFromConnector } from '../../pes-my-products-connector/utils';
import { getSingleProductList, isProductUpdated, isSingleProductInListFinally, } from '../../../globals/my-products/utils';
import { getAPCDistributor } from '../../commerce-connector/utils';
import { initSDLHeaderResizeObserver } from '../../../globals/stickyBar.utils';
import { getAnalyticsPageLoadData, getLocaleCodes, getDataForEcommerceAnalyticsEvent } from '../../../globals/utils/helpers';
import { ProductMainUI } from './product-main-ui';
import { storeBreadcrumbs } from '../../breadcrumbs/utils';
export class ProductMain {
  constructor() {
    var _a;
    this.headerHeight = null;
    this.notificationController = new NotificationBannerController();
    this.buttonsBuyOnlineAvailability = {};
    this.unifiedCheckoutFlag = (_a = ConfiguratorHandler.getSingleConfig('FeatureFlags')) === null || _a === void 0 ? void 0 : _a.unifiedCheckout;
    this.isUnifiedCheckoutEnabled = ConfiguratorHandler.isFeatureFlagEnabled(this.unifiedCheckoutFlag || {});
    this.ctaLocation = gaLocationNames[pesCatalogPageTypes.PRODUCT] || '';
    this.breakpointListener = (e) => {
      this.isMobile = !e.matches;
    };
    this.updateActiveProductData = async () => {
      const { status, activeProductTab, data, lastActionType } = this.getState();
      const watchedActionTypes = [
        ACTION_TYPES.SET_ACTIVE_PRODUCT_TAB,
        ACTION_TYPES.START_LOADING,
        ACTION_TYPES.STOP_LOADING,
      ];
      if (!watchedActionTypes.includes(lastActionType))
        return;
      if (this.status !== status) {
        this.status = status;
      }
      if (this.activeProductTab !== activeProductTab) {
        this.activeProductTab = activeProductTab;
        this.productId = data[activeProductTab].base.productId;
        this.localeCode = data[activeProductTab].base.localeCode;
        this.ctaArea = data[activeProductTab].base.ctaArea;
        this.links = data[activeProductTab].base.links;
        this.labels = data[activeProductTab].base.labels;
        this.productStatus = data[activeProductTab].base.productStatus;
        this.substitutions = data[activeProductTab].base.substitutions;
        this.productMedia = data[activeProductTab].base.productMedia;
        this.variants = data[activeProductTab].base.variants;
        this.masterRange = data[activeProductTab].base.masterRange;
        this.productInfo = data[activeProductTab].base.productInfo;
        this.highlightedCharacteristics = data[activeProductTab].base.highlightedCharacteristics;
        this.offlineStores = data[activeProductTab].base.offlineStores;
        this.materialPriceGroup = data[activeProductTab].base.materialPriceGroup;
        this.productSelectorConfig = data[activeProductTab].base.productSelectorConfig;
        this.rangeSelectorConfig = data[activeProductTab].base.rangeSelectorConfig;
        this.bulletPoints = data[activeProductTab].base.bulletPoints;
        this.bulletPointsLimit = data[activeProductTab].base.bulletPointsLimit;
        this.environmentalData = data[activeProductTab].base.environmentalData;
        this.sustainability = data[activeProductTab].base.sustainability;
        this.prioritizeBuyNowButton = data[activeProductTab].base.prioritizeBuyNowButton;
        this.bazaarVoiceInfo = data[activeProductTab].base.bazaarVoiceInfo;
        this.productCR = data[activeProductTab].base.productCR;
        this.co2message = data[activeProductTab].base.co2message;
        this.tags = data[activeProductTab].base.tags;
        this.alternatives = data[activeProductTab].alternatives;
        this.externalUrlConfig = data[activeProductTab].externalUrlConfig;
        this.externaProductData = data[activeProductTab].externaProductData;
        this.productSoftwareDocuments = data[activeProductTab].base.softwareDocuments;
        this.ccBuyOnlineAvailability = this.buttonsBuyOnlineAvailability[this.productId];
        try {
          await Promise.all([
            this.requestMyProducts(),
            this.requestSoftwareProducts(),
            this.updateProductSelectorStatus(),
            this.requestProductAvailabilityInfo(),
          ]);
        }
        catch (error) {
          console.error(`[PES]: Error fetching additional product data:\n${error.message}`);
        }
      }
    };
    this.handleApcFavoritesClick = async () => {
      var _a, _b;
      if (this.favoritesButtonDisabled) {
        return;
      }
      if (!((_b = (_a = this.productAvailabilityInfo) === null || _a === void 0 ? void 0 : _a.addToFavoritesInfo) === null || _b === void 0 ? void 0 : _b.loggedUser)) {
        this.displayLogInPopup = true;
        return;
      }
      this.favoritesButtonDisabled = true;
      try {
        if (this.giftId) {
          await this.handleApcRemovedFromFavorites();
        }
        else {
          await this.handleApcAddedToFavorites();
        }
      }
      finally {
        this.favoritesButtonDisabled = false;
      }
    };
    this.handleSignInButtonDidClick = () => {
      var _a, _b;
      window.open(signInUrl((_b = (_a = this.apcCta) === null || _a === void 0 ? void 0 : _a.urls) === null || _b === void 0 ? void 0 : _b.apcHost, this.localeCode, this.productId), '_self');
    };
    this.handleCreateAccountButtonDidClick = () => {
      var _a, _b;
      window.open(createAccountUrl((_b = (_a = this.apcCta) === null || _a === void 0 ? void 0 : _a.urls) === null || _b === void 0 ? void 0 : _b.apcHost, this.localeCode, this.productId), '_self');
    };
    this.handleAddToMyProducts = (type, event) => {
      if (this.favoritesButtonDisabled) {
        return;
      }
      const { initialEvent, isStickyBar } = event.detail;
      if (!isAppRoutingEnabled()) {
        this.favoritesButtonDisabled = true;
      }
      this.ctaClick.emit({
        inList: isAppRoutingEnabled()
          ? getIsProductsInCustomFavorites([this.productId])
          : this.isInMyProductsList,
        product: {
          id: this.productId,
        },
        type,
        initialEvent,
        onFinish: (result) => this.handleFinishAddToMyProducts(result, isStickyBar),
      });
    };
    this.sendAnalyticsForAddToMyProducts = (response, isSticky) => {
      if ((response === null || response === void 0 ? void 0 : response.status) === myProductsResponseStatus.SUCCESS) {
        const { infoForGa } = response;
        const { brand = '', currency = '', description, price = null } = infoForGa[this.productId];
        const product = {
          brand,
          price,
          category: '',
          id: this.productId,
          name: description,
          quantity: 1,
        };
        const isProductAdded = isProductUpdated(this.productId, response);
        if (isProductAdded) {
          send(addToCartMainEvent, {
            currencyCode: currency,
            distributor: '',
            products: [Object.assign(Object.assign({}, product), { variant: '' })],
            isSticky,
          });
        }
        else {
          send(removeFromFavoritesEvent, {
            currencyCode: currency,
            products: [product],
          });
        }
      }
    };
    this.handleFinishAddToMyProducts = (result, isStickyBar) => {
      var _a;
      this.favoritesButtonDisabled = false;
      this.isInMyProductsList = (_a = isSingleProductInListFinally(this.productId, result)) !== null && _a !== void 0 ? _a : this.isInMyProductsList;
      if (isAnalyticsEnabled()) {
        this.sendAnalyticsForAddToMyProducts(result, isStickyBar);
      }
    };
    this.isInFavorites = () => {
      if (this.isApc()) {
        return !!this.giftId;
      }
      if (isAppRoutingEnabled()) {
        return getIsProductsInCustomFavorites([this.productId]);
      }
      return this.isInMyProductsList;
    };
    this.onRangeLinkClick = async (event) => {
      event.preventDefault();
      const { consumer, storageName } = getConsumerSpecificData(this.isPBS, `${this.host}${this.countryCode}/${this.languageCode}/`);
      const currentPageStorageKey = `${PageNames.PRODUCT}/${this.productId}`;
      indexDBBreadcrumbs.setChannel(consumer);
      try {
        const breadcrumbs = await indexDBBreadcrumbs.getValidatedBreadcrumbs({
          storageName,
          key: currentPageStorageKey,
        });
        const filteredBreadCrumbs = breadcrumbs.slice(0, -2);
        const { name, id, url } = breadcrumbs.find((item) => item.itemType === RANGE);
        await storeBreadcrumbs({
          name,
          id,
          url,
          storageName,
          breadcrumbs: filteredBreadCrumbs,
          pageName: PageNames.RANGE,
        });
      }
      catch (e) {
        console.error(`[PES]: Breadcrumbs can not be fetched from indexDB storage ${currentPageStorageKey}`, e);
      }
    };
    this.filterCircularProductMainCards = () => {
      return this.circularProductMainCards.filter(({ commercialReference }) => {
        return this.availableCircularProducts[commercialReference];
      });
    };
    this.prepareItemsForGA = (pageTopCategory) => {
      return this.filterCircularProductMainCards()
        .map(({ commercialReference, circularType, description, price, circularProductRelationships, }, selectedCardIndex) => {
        var _a, _b, _c;
        return ({
          index: selectedCardIndex + 1,
          item_category: (_a = capitalizeFirstLetter(circularType)) !== null && _a !== void 0 ? _a : '',
          item_id: commercialReference !== null && commercialReference !== void 0 ? commercialReference : '',
          item_name: description !== null && description !== void 0 ? description : '',
          item_variant: (_c = (_b = circularProductRelationships[0]) === null || _b === void 0 ? void 0 : _b.productId) !== null && _c !== void 0 ? _c : '',
          price: formatPrice(price),
          item_list_name: pageTopCategory !== null && pageTopCategory !== void 0 ? pageTopCategory : '',
          quantity: 1,
        });
      });
    };
    this.productContentRef = null;
    this.handleResizeWindow = () => {
      this.getParentWidth();
      this.setMediaGalleryStickiness();
    };
    this.getParentWidth = () => {
      var _a, _b;
      this.parentWidth = ((_a = this.productContentRef) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) < MAX_PDP_WIDTH
        ? (_b = this.productContentRef) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().width
        : MAX_PDP_WIDTH;
    };
    this.prepareSoftwareDocuments = (productSoftwareDocuments) => {
      if (isEmpty(productSoftwareDocuments))
        return;
      return productSoftwareDocuments.map((documentInfo) => {
        var _a;
        const softwareDocumentInfo = cloneDeep(documentInfo);
        if (isViewOnline(documentInfo === null || documentInfo === void 0 ? void 0 : documentInfo.documentName) && ((_a = documentInfo === null || documentInfo === void 0 ? void 0 : documentInfo.files) === null || _a === void 0 ? void 0 : _a.length) === 1) {
          const { size, format } = documentInfo.files[0];
          softwareDocumentInfo.size = size;
          softwareDocumentInfo.format = format;
        }
        return softwareDocumentInfo;
      });
    };
    this.handleDownloadClick = () => {
      var _a, _b;
      const docs = this.softwareDocuments;
      if (!(docs === null || docs === void 0 ? void 0 : docs.length)) {
        return;
      }
      if (((_a = this.softwareDocuments) === null || _a === void 0 ? void 0 : _a.length) > 1) {
        this.openSoftwareDocumentsDialog();
      }
      else {
        const { documentReference, documentName, documentType, link, files, downloadAll } = docs[0];
        const hasDownloadLink = downloadAll || (files && ((_b = files[0]) === null || _b === void 0 ? void 0 : _b.link));
        if ((documentName === ONLINE_VIEW || documentName === VIEW_ONLINE) && hasDownloadLink) {
          this.openSoftwareDocumentsDialog();
        }
        else {
          window.open(link);
          if (!isAnalyticsEnabled())
            return;
          send(documentDownloadEvent, {
            documentName,
            documentType,
            documentId: documentReference,
          });
        }
      }
    };
    this.openSoftwareDocumentsDialog = () => {
      this.softwareDocumentsDialogOpen = true;
      if (!isAnalyticsEnabled())
        return;
      send(onlineSoftwareModalClickEvent, PDP_SOFTWARE);
    };
    this.handleDownloadModalClose = () => {
      this.softwareDocumentsDialogOpen = false;
    };
    this.gatherAdditionalInfo = () => {
      var _a;
      if (((_a = this.softwareDocuments) === null || _a === void 0 ? void 0 : _a.length) !== 1)
        return null;
      const softwareInfo = softwareDocumentsToSoftwareInfo(this.softwareDocuments, this.labels);
      return additionalInfoData(softwareInfo);
    };
    this.setMediaGalleryStickiness = () => {
      var _a;
      if (!isBrowser())
        return;
      this.isMediaGalleryFitsToViewport = ((_a = this.mediaGalleryRef) === null || _a === void 0 ? void 0 : _a.clientHeight) <= window.innerHeight;
      this.setMediaGalleryStickinessPosition();
    };
    this.setMediaGalleryStickinessPosition = () => {
      if (isBrowser()) {
        if (this.mediaGalleryRef) {
          if (this.isMediaGalleryFitsToViewport) {
            this.mediaGalleryRef.style.top = `${this.headerHeight}px`;
          }
          else {
            this.mediaGalleryRef.style.top = null;
          }
        }
      }
    };
    this.getMyProductsRelatedProps = () => {
      var _a, _b, _c, _d, _e, _f, _g;
      if (window.isApc) {
        const addToFavoritesInfo = (_a = this.productAvailabilityInfo) === null || _a === void 0 ? void 0 : _a.addToFavoritesInfo;
        return {
          addToMyProductsLabel: (_c = (_b = this.apcCta) === null || _b === void 0 ? void 0 : _b.labels) === null || _c === void 0 ? void 0 : _c.addToFavorites,
          removeFromMyProductsLabel: (_e = (_d = this.apcCta) === null || _d === void 0 ? void 0 : _d.labels) === null || _e === void 0 ? void 0 : _e.removeFromFavorites,
          showFavorites: !!addToFavoritesInfo,
        };
      }
      const labels = (_g = (_f = this.links) === null || _f === void 0 ? void 0 : _f.ADD_TO_MY_PRODUCTS) === null || _g === void 0 ? void 0 : _g.labels;
      return {
        addToMyProductsLabel: labels === null || labels === void 0 ? void 0 : labels.defaultLabel,
        removeFromMyProductsLabel: labels === null || labels === void 0 ? void 0 : labels.removeLabel,
        showFavorites: isAppRoutingEnabled() ? getIsCustomAddToFavoritesEnabled() : !!labels,
      };
    };
    this.handleAuthPopupClose = () => {
      this.displayLogInPopup = false;
    };
    this.hasCTAAreaContainer = () => {
      var _a, _b;
      if (!isBrowser()) {
        return true;
      }
      const isCta = (this.ctaArea && !!Object.keys(((_a = this.ctaArea) === null || _a === void 0 ? void 0 : _a.buttons) || {}).length)
        || (this.apcCta && !!Object.keys(((_b = this.apcCta) === null || _b === void 0 ? void 0 : _b.urls) || {}).length);
      if (!!this.shopSeLink
        || isCta
        || !!this.ctaArea.price
        || this.hasSlottedDiscountedPrice
        || !!this.productSelectorConfig.enableProductSelectorButton
        || this.isUnifiedCheckoutEnabled)
        return true;
      if (this.isMobile) {
        return (this.showCompare
          || this.getMyProductsRelatedProps().showFavorites);
      }
      return false;
    };
    this.renderPriceCtaContainer = (showFavorites, addToMyProductsLabel, removeFromMyProductsLabel, compareLabel, downloadLabel) => {
      var _a;
      return (h("pes-cta-area-container", { class: {
          'product-main__cta-area': true,
          'product-main__section': true,
          'product-main__section--cta-area': true,
          'product-main__section--hidden': !this.hasCTAAreaContainer(),
        }, slot: "slot-price-cta-container", isApc: this.isApc(), productId: this.productId, apcCta: this.apcCta, availabilityInfo: this.productAvailabilityInfo, isInFavorites: !!this.giftId, commerceConnectorSettings: this.commerceConnectorSettings, productsFeed: this.productsFeed, ctaData: this.ctaArea, shoppableRedirectionData: this.shoppableRedirectionData, shopSeLink: this.shopSeLink, showShopSeLoader: this.showShopSeLoader, productCR: this.productCR || '', showSkeleton: this.loading || this.isCircularProductLoading, showFavorites: showFavorites, addToMyProductsLabel: addToMyProductsLabel, removeFromMyProductsLabel: removeFromMyProductsLabel, compareLabel: compareLabel, downloadLabel: downloadLabel, showCompare: this.showCompare, showBuyOnline: this.showBuyOnline && this.ccBuyOnlineAvailability, isInMyProductsList: this.isInMyProductsList, materialPriceGroup: this.materialPriceGroup, softwareDocuments: this.softwareDocuments, selectorConfig: this.selectorConfig, showProductSelectorStatus: this.showProductSelectorStatus, circularEconomyInfo: this.circularEconomy ? null : this.circularEconomyInfo, prioritizeBuyNowButton: this.prioritizeBuyNowButton, localeCode: this.localeCode, countryCode: this.countryCode, isPBS: this.isPBS, stockQuantityLabel: this.stockQuantityLabel, isCircularProduct: this.activeProductTab !== CircularProductTypes.LINEAR, currentProductFeed: (_a = this.storedProductsFeed) === null || _a === void 0 ? void 0 : _a.find(({ ProductId }) => ProductId === this.productId), labels: this.labels, marketPlacePdpUrl: this.marketplacePdpUrl }, h("slot", { name: "discounted-price", slot: "discounted-price" })));
    };
    this.setMediaGalleryRef = (el) => {
      this.mediaGalleryRef = el;
    };
    this.setProductContentRef = (el) => {
      this.productContentRef = el;
    };
    this.productId = undefined;
    this.productCR = undefined;
    this.localeCode = undefined;
    this.links = undefined;
    this.ctaArea = undefined;
    this.shoppableRedirectionData = undefined;
    this.masterRange = undefined;
    this.productInfo = undefined;
    this.highlightedCharacteristics = undefined;
    this.offlineStores = undefined;
    this.productStatus = undefined;
    this.variants = undefined;
    this.rangeSelectorConfig = undefined;
    this.productSelectorConfig = undefined;
    this.substitutions = undefined;
    this.alternatives = undefined;
    this.materialPriceGroup = undefined;
    this.productSoftware = undefined;
    this.labels = undefined;
    this.commerceConnectorSettings = null;
    this.productsFeed = null;
    this.bulletPoints = null;
    this.bulletPointsLimit = 0;
    this.sustainability = null;
    this.prioritizeBuyNowButton = false;
    this.environmentalData = undefined;
    this.circularEconomyInfo = undefined;
    this.co2message = undefined;
    this.circularEconomy = undefined;
    this.circularProductRelationships = undefined;
    this.circularProductMainCards = undefined;
    this.productSoftwareDocuments = undefined;
    this.goToB2C = undefined;
    this.tags = undefined;
    this.isPBS = undefined;
    this.isExternalConsumer = undefined;
    this.externalUrlConfig = undefined;
    this.externaProductData = undefined;
    this._bulletPoints = undefined;
    this._bulletPointsLimit = undefined;
    this._sustainability = undefined;
    this._productId = undefined;
    this._productCR = undefined;
    this._localeCode = undefined;
    this._links = undefined;
    this._ctaArea = undefined;
    this._shoppableRedirectionData = undefined;
    this._masterRange = undefined;
    this._productInfo = undefined;
    this._highlightedCharacteristics = undefined;
    this._offlineStores = undefined;
    this._productStatus = undefined;
    this._variants = undefined;
    this._rangeSelectorConfig = undefined;
    this._productSelectorConfig = undefined;
    this._substitutions = undefined;
    this._commerceConnectorSettings = undefined;
    this._materialPriceGroup = undefined;
    this._productSoftware = undefined;
    this._productsFeed = undefined;
    this._labels = undefined;
    this._alternatives = undefined;
    this._prioritizeBuyNowButton = undefined;
    this._externalUrlConfig = undefined;
    this._externaProductData = undefined;
    this._environmentalData = undefined;
    this._co2message = undefined;
    this._circularEconomyInfo = undefined;
    this._circularEconomy = undefined;
    this._circularProductRelationships = undefined;
    this._circularProductMainCards = undefined;
    this._productSoftwareDocuments = undefined;
    this.showCompare = true;
    this.enableCommerceConnector = true;
    this.showBuyOnline = true;
    this.productMedia = undefined;
    this.host = undefined;
    this.languageCode = undefined;
    this.migration = undefined;
    this.stickyBarRef = undefined;
    this._showCompare = undefined;
    this._enableCommerceConnector = undefined;
    this._productMedia = undefined;
    this.priceSpiderInfo = undefined;
    this.bazaarVoiceInfo = undefined;
    this._priceSpiderInfo = undefined;
    this._bazaarVoiceInfo = undefined;
    this.marketplacePdpUrl = undefined;
    this._goToB2C = undefined;
    this._tags = undefined;
    this.countryCode = undefined;
    this.showProductSelectorStatus = {
      isExternalState: true,
      loaded: false,
      state: false,
    };
    this.loading = true;
    this.ccProductIdToShow = undefined;
    this.ccBuyOnlineAvailability = false;
    this.parentWidth = undefined;
    this.softwareDocuments = [];
    this.softwareDocumentsDialogOpen = false;
    this.isInMyProductsList = false;
    this.favoritesButtonDisabled = false;
    this.isMediaGalleryFitsToViewport = true;
    this.status = STATUS_TYPES.IDLE;
    this.activeProductTab = this.getState().activeProductTab;
    this.apcCta = null;
    this.productAvailabilityInfo = null;
    this._apcCta = undefined;
    this._productAvailabilityInfo = undefined;
    this.additionalDistributors = undefined;
    this.displayLogInPopup = false;
    this.giftId = null;
    this.shopSeLink = null;
    this.showShopSeLoader = false;
    this.selectorConfig = null;
    this.isCircularProductEnabled = false;
    this.isCircularProductAvailable = false;
    this.isStockAvailabilityChecked = false;
    this.availableCircularProducts = {};
    this.analyticsPageData = undefined;
    this.isCircularProductLoading = false;
    this.stockQuantityLabel = undefined;
    this.isMobile = false;
    this.circularProductsAvailableQuantity = 0;
    this.storedProductsFeed = [];
  }
  onApcCtaButtonDidClick(event) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    if (event.detail.buttonType === EApcButtonType.ADD_TO_CART) {
      let gaObj = null;
      if (isAnalyticsEnabled()) {
        const product = {
          brand: (_a = this.productInfo) === null || _a === void 0 ? void 0 : _a.brand,
          price: (_c = (_b = this.productAvailabilityInfo) === null || _b === void 0 ? void 0 : _b.prices) === null || _c === void 0 ? void 0 : _c[this.productId].activePriceValue,
          category: '',
          id: this.productId,
          name: this.productInfo.description,
          quantity: 1,
        };
        gaObj = {
          currencyCode: ((_e = (_d = this.productAvailabilityInfo) === null || _d === void 0 ? void 0 : _d.prices) === null || _e === void 0 ? void 0 : _e[this.productId].activePriceValue)
            ? this.ctaArea.currency
            : 'EUR',
          distributor: '',
          products: [Object.assign(Object.assign({}, product), { variant: '' })],
        };
      }
      addToCart(this.notificationController, this.productId, this.localeCode, (_g = (_f = this.apcCta) === null || _f === void 0 ? void 0 : _f.urls) === null || _g === void 0 ? void 0 : _g.apcHost, (_j = (_h = this.apcCta) === null || _h === void 0 ? void 0 : _h.labels) === null || _j === void 0 ? void 0 : _j.failedResponse, (_l = (_k = this.commerceConnectorSettings) === null || _k === void 0 ? void 0 : _k.options) === null || _l === void 0 ? void 0 : _l.agentChatCscId, gaObj);
    }
  }
  onNotifyClick(e) {
    window.open(e.detail, '_blank');
  }
  onPromotedClick(e) {
    window.open(e.detail, '_blank');
  }
  onProductBuyOnlineClick(e) {
    if (e.detail) {
      window.open(e.detail, '_blank');
      return;
    }
    if (!this.enableCommerceConnector || !this.ccBuyOnlineAvailability) {
      return;
    }
    this.ccProductIdToShow = this.productId;
    if (!isAnalyticsEnabled())
      return;
    if (this.activeProductTab === CircularProductTypes.LINEAR) {
      send(buyOnlineVirtualPageEvent);
    }
    else {
      send(buyOnlineCircularVirtualPageEvent, { circularType: capitalizeFirstLetter(this.activeProductTab) });
    }
  }
  onCCBtnBuyOnlineAvailability(e) {
    var _a;
    if (this.enableCommerceConnector) {
      this.buttonsBuyOnlineAvailability = Object.assign(Object.assign({}, this.buttonsBuyOnlineAvailability), e.detail);
      this.ccBuyOnlineAvailability = this.buttonsBuyOnlineAvailability[this.productId];
      if (!this.ccBuyOnlineAvailability
        && !!((_a = this.ctaArea.buttons) === null || _a === void 0 ? void 0 : _a["BUY_ONLINE_BUTTON_REGULAR"])) {
        this.ctaArea = Object.assign(Object.assign({}, this.ctaArea), { buttons: omit(this.ctaArea.buttons, "BUY_ONLINE_BUTTON_REGULAR") });
      }
    }
  }
  onChannelSightResponse(e) {
    this.productsFeed = e === null || e === void 0 ? void 0 : e.detail;
  }
  onCCDialogClosed() {
    this.ccProductIdToShow = undefined;
  }
  onCCPricesReceived(e) {
    if (e.detail.priceFromLabel) {
      this.labels.partnerPriceLabel = e.detail.priceFromLabel;
    }
  }
  handleAddToMyProductsButtonClick(event) {
    if (this.isApc()) {
      this.handleApcFavoritesClick();
    }
    else {
      this.handleAddToMyProducts('favorites', event);
    }
  }
  handleAddToCartButtonClick(event) {
    this.handleAddToMyProducts('cart', event);
  }
  handleDownloadButtonDidClick() {
    this.handleDownloadClick();
  }
  getLinks() {
    var _a;
    if (this.isPBS)
      return {};
    return (_a = tryParse(this._links)) !== null && _a !== void 0 ? _a : this.links;
  }
  getOfflineStores() {
    var _a;
    if (this.isPBS)
      return {};
    return (_a = tryParse(this._offlineStores)) !== null && _a !== void 0 ? _a : this.offlineStores;
  }
  onMarketplaceDidClick(e) {
    const marketplaceProduct = e.detail;
    window.open(marketplaceProduct.link, '_blank');
    send(exitToSchneiderEvent, { link_url: marketplaceProduct.link });
    if (this.isUnifiedCheckoutEnabled)
      return;
    if (!marketplaceProduct.gaAttributes) {
      console.warn('[PES]: Could not find gaAttributes from API response');
      return;
    }
    triggerCtaClickEvent({
      cta_id: marketplaceProduct.gaAttributes.product,
      cta_name: marketplaceProduct.gaAttributes.type,
      cta_link: marketplaceProduct.link,
      cta_location: this.ctaLocation,
      cta_category: virtualPagesNames.BUY_ONLINE,
    });
  }
  componentWillLoad() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22;
    this.productMedia = (_a = tryParse(this._productMedia)) !== null && _a !== void 0 ? _a : this.productMedia;
    this.productId = (_b = tryParse(this._productId)) !== null && _b !== void 0 ? _b : this.productId;
    this.productCR = (_c = tryParse(this._productCR)) !== null && _c !== void 0 ? _c : this.productCR;
    this.localeCode = (_d = tryParse(this._localeCode)) !== null && _d !== void 0 ? _d : this.localeCode;
    this.links = this.getLinks();
    this.ctaArea = (_e = tryParse(this._ctaArea)) !== null && _e !== void 0 ? _e : this.ctaArea;
    this.masterRange = (_f = tryParse(this._masterRange)) !== null && _f !== void 0 ? _f : this.masterRange;
    this.productInfo = (_g = tryParse(this._productInfo)) !== null && _g !== void 0 ? _g : this.productInfo;
    this.highlightedCharacteristics = (_h = tryParse(this._highlightedCharacteristics)) !== null && _h !== void 0 ? _h : this.highlightedCharacteristics;
    this.offlineStores = this.getOfflineStores();
    this.productStatus = (_j = tryParse(this._productStatus)) !== null && _j !== void 0 ? _j : this.productStatus;
    this.variants = (_k = tryParse(this._variants)) !== null && _k !== void 0 ? _k : this.variants;
    this.rangeSelectorConfig = (_l = tryParse(this._rangeSelectorConfig)) !== null && _l !== void 0 ? _l : this.rangeSelectorConfig;
    this.productSelectorConfig = (_m = tryParse(this._productSelectorConfig)) !== null && _m !== void 0 ? _m : this.productSelectorConfig;
    this.substitutions = (_o = tryParse(this._substitutions)) !== null && _o !== void 0 ? _o : this.substitutions;
    this.materialPriceGroup = (_p = tryParse(this._materialPriceGroup)) !== null && _p !== void 0 ? _p : this.materialPriceGroup;
    this.productSoftware = (_q = tryParse(this._productSoftware)) !== null && _q !== void 0 ? _q : this.productSoftware;
    this.labels = (_r = tryParse(this._labels)) !== null && _r !== void 0 ? _r : this.labels;
    this.commerceConnectorSettings = (_s = tryParse(this._commerceConnectorSettings)) !== null && _s !== void 0 ? _s : this.commerceConnectorSettings;
    this.productsFeed = (_t = tryParse(this._productsFeed)) !== null && _t !== void 0 ? _t : this.productsFeed;
    this.showCompare = (_u = tryParse(this._showCompare)) !== null && _u !== void 0 ? _u : this.showCompare;
    this.enableCommerceConnector = (_v = tryParse(this._enableCommerceConnector)) !== null && _v !== void 0 ? _v : this.enableCommerceConnector;
    this.priceSpiderInfo = (_w = tryParse(this._priceSpiderInfo)) !== null && _w !== void 0 ? _w : this.priceSpiderInfo;
    this.bazaarVoiceInfo = (_x = tryParse(this._bazaarVoiceInfo)) !== null && _x !== void 0 ? _x : this.bazaarVoiceInfo;
    this.apcCta = (_y = tryParse(this._apcCta)) !== null && _y !== void 0 ? _y : this.apcCta;
    this.productAvailabilityInfo = (_z = tryParse(this._productAvailabilityInfo)) !== null && _z !== void 0 ? _z : this.productAvailabilityInfo;
    this.bulletPoints = (_0 = tryParse(this._bulletPoints)) !== null && _0 !== void 0 ? _0 : this.bulletPoints;
    this.bulletPointsLimit = (_1 = tryParse(this._bulletPointsLimit)) !== null && _1 !== void 0 ? _1 : this.bulletPointsLimit;
    this.sustainability = (_2 = tryParse(this._sustainability)) !== null && _2 !== void 0 ? _2 : this.sustainability;
    this.alternatives = (_3 = tryParse(this._alternatives)) !== null && _3 !== void 0 ? _3 : this.alternatives;
    this.prioritizeBuyNowButton = (_4 = tryParse(this._prioritizeBuyNowButton)) !== null && _4 !== void 0 ? _4 : this.prioritizeBuyNowButton;
    this.circularEconomyInfo = (_5 = tryParse(this._circularEconomyInfo)) !== null && _5 !== void 0 ? _5 : this.circularEconomyInfo;
    this.countryCode = (_6 = this.countryCode) !== null && _6 !== void 0 ? _6 : getLocaleCodes(this.localeCode).countryCode;
    this.externalUrlConfig = (_7 = tryParse(this._externalUrlConfig)) !== null && _7 !== void 0 ? _7 : this.externalUrlConfig;
    this.externaProductData = (_8 = tryParse(this._externaProductData)) !== null && _8 !== void 0 ? _8 : this.externaProductData;
    this.co2message = (_9 = tryParse(this._co2message)) !== null && _9 !== void 0 ? _9 : this.co2message;
    this.environmentalData = (_10 = tryParse(this._environmentalData)) !== null && _10 !== void 0 ? _10 : this.environmentalData;
    this.languageCode = (_11 = this.languageCode) !== null && _11 !== void 0 ? _11 : getLocaleCodes(this.localeCode).languageCode;
    this.circularEconomy = (_12 = tryParse(this._circularEconomy)) !== null && _12 !== void 0 ? _12 : this.circularEconomy;
    this.circularProductRelationships = (_13 = tryParse(this._circularProductRelationships)) !== null && _13 !== void 0 ? _13 : this.circularProductRelationships;
    this.circularProductMainCards = (_14 = tryParse(this._circularProductMainCards)) !== null && _14 !== void 0 ? _14 : this.circularProductMainCards;
    this.productSoftwareDocuments = (_15 = tryParse(this._productSoftwareDocuments)) !== null && _15 !== void 0 ? _15 : this.productSoftwareDocuments;
    this.goToB2C = (_16 = tryParse(this._goToB2C)) !== null && _16 !== void 0 ? _16 : this.goToB2C;
    this.tags = (_17 = tryParse(this._tags)) !== null && _17 !== void 0 ? _17 : this.tags;
    this.marketplacePdpUrl = (_19 = (_18 = this.marketplacePdpUrl) === null || _18 === void 0 ? void 0 : _18.replace) === null || _19 === void 0 ? void 0 : _19.call(_18, 'cta_location=<location>', `cta_location=${this.ctaLocation}`);
    if (isBrowser()) {
      this.mql = window.matchMedia('(min-width: 980px)');
      this.isMobile = !this.mql.matches;
      this.mql.addEventListener('change', this.breakpointListener);
    }
    const shoppableData = (_20 = tryParse(this._shoppableRedirectionData)) !== null && _20 !== void 0 ? _20 : this.shoppableRedirectionData;
    this.shoppableRedirectionData = shoppableData;
    if (shoppableData) {
      this.handleRouteToShopSe(shoppableData);
    }
    this.isCircularProductEnabled = this.circularEconomy && !!((_22 = (_21 = this.circularProductRelationships) === null || _21 === void 0 ? void 0 : _21[0]) === null || _22 === void 0 ? void 0 : _22.productId);
    if (!this.isCircularProductEnabled)
      return;
    if (!isBrowser())
      return;
    const standardProductData = {
      base: {
        productId: this.productId,
        localeCode: this.localeCode,
        ctaArea: this.ctaArea,
        links: this.links,
        labels: this.labels,
        productStatus: this.productStatus,
        substitutions: this.substitutions,
        productMedia: this.productMedia,
        variants: this.variants,
        masterRange: this.masterRange,
        productInfo: this.productInfo,
        highlightedCharacteristics: this.highlightedCharacteristics,
        offlineStores: this.offlineStores,
        materialPriceGroup: this.materialPriceGroup,
        productSelectorConfig: this.productSelectorConfig,
        rangeSelectorConfig: this.rangeSelectorConfig,
        environmentalData: this.environmentalData,
        sustainability: this.sustainability,
        prioritizeBuyNowButton: this.prioritizeBuyNowButton,
        productCR: this.productCR,
        bulletPoints: this.bulletPoints,
        bulletPointsLimit: this.bulletPointsLimit,
        softwareDocuments: this.productSoftwareDocuments,
        tags: this.tags,
      },
      alternatives: this.alternatives,
      externalUrlConfig: this.externalUrlConfig,
      externaProductData: this.externaProductData,
    };
    store.dispatch(setLinearProductData(standardProductData));
    this.unsubscribe = store.subscribe(this.updateActiveProductData);
    if (!isAnalyticsEnabled())
      return;
    this.analyticsPageData = getAnalyticsPageLoadData();
  }
  componentWillRender() {
    if (!this.isCircularProductEnabled || !this.circularEconomy)
      return;
    const { stockQuantityLabel: stockQuantityLabelTemplate } = this.circularEconomy;
    const isStockQuantityLabelAvailable = this.activeProductTab !== CircularProductTypes.LINEAR
      && this.circularProductsAvailableQuantity;
    this.stockQuantityLabel = isStockQuantityLabelAvailable
      ? stockQuantityLabelTemplate.replace('#stockquantity#', this.circularProductsAvailableQuantity.toString()) : null;
    this.isCircularProductLoading = this.status === STATUS_TYPES.LOADING
      || this.status === STATUS_TYPES.FAILED;
  }
  getState() {
    return store.getState().product;
  }
  getCircularProductData(productType) {
    return this.getState().data[productType];
  }
  async handleRouteToShopSe(shoppableData) {
    const shopeSeHost = shoppableData.link.shopableRedirectionHostUrl;
    try {
      const response = await routeToShopSeUtils(shopeSeHost, this.productCR, this.localeCode);
      if (!response)
        return;
      this.shopSeLink = response;
      this.ctaArea = updateBuyOnlineButtonLabel(this.ctaArea, shoppableData.shoppableBuyButtonLabel);
    }
    catch (error) {
      console.error(error);
    }
    finally {
      this.showShopSeLoader = false;
    }
  }
  isApc() {
    var _a, _b;
    return !!((_b = (_a = this.commerceConnectorSettings) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.isApcSite);
  }
  favoritesMessageWithLink(message) {
    var _a, _b, _c, _d;
    const apcHost = (_b = (_a = this.apcCta) === null || _a === void 0 ? void 0 : _a.urls) === null || _b === void 0 ? void 0 : _b.apcHost;
    const linkLabel = (_d = (_c = this.apcCta) === null || _c === void 0 ? void 0 : _c.labels) === null || _d === void 0 ? void 0 : _d.favorites;
    return `${message} <a href="${myAccountListUrl(apcHost, this.localeCode)}" target="_blank" style="color:#fff; text-decoration:underline">${linkLabel}</a>`;
  }
  async handleApcAddedToFavorites() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const { showAddingNotification, giftListId, } = (_b = (_a = this.productAvailabilityInfo) === null || _a === void 0 ? void 0 : _a.addToFavoritesInfo) !== null && _b !== void 0 ? _b : {};
    const response = await addToFavorites({
      hostUrl: (_d = (_c = this.apcCta) === null || _c === void 0 ? void 0 : _c.urls) === null || _d === void 0 ? void 0 : _d.apcHost,
      localeCode: this.localeCode,
      notificationController: this.notificationController,
      showAddingNotification,
      notificationMessages: {
        success: this.favoritesMessageWithLink((_f = (_e = this.apcCta) === null || _e === void 0 ? void 0 : _e.labels) === null || _f === void 0 ? void 0 : _f.itemAddedTo),
        error: (_h = (_g = this.apcCta) === null || _g === void 0 ? void 0 : _g.labels) === null || _h === void 0 ? void 0 : _h.failedResponse,
      },
      data: {
        productId: this.productId,
        giftlistId: giftListId,
      },
    });
    const [{ repositoryId }] = (_j = response === null || response === void 0 ? void 0 : response.addedItems) !== null && _j !== void 0 ? _j : [{}];
    this.giftId = repositoryId;
  }
  async handleApcRemovedFromFavorites() {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { showAddingNotification, giftListId, } = (_b = (_a = this.productAvailabilityInfo) === null || _a === void 0 ? void 0 : _a.addToFavoritesInfo) !== null && _b !== void 0 ? _b : {};
    await removeFromFavorites({
      hostUrl: (_d = (_c = this.apcCta) === null || _c === void 0 ? void 0 : _c.urls) === null || _d === void 0 ? void 0 : _d.apcHost,
      localeCode: this.localeCode,
      notificationController: this.notificationController,
      showAddingNotification,
      notificationMessages: {
        success: this.favoritesMessageWithLink((_f = (_e = this.apcCta) === null || _e === void 0 ? void 0 : _e.labels) === null || _f === void 0 ? void 0 : _f.itemRemovedFrom),
        error: (_h = (_g = this.apcCta) === null || _g === void 0 ? void 0 : _g.labels) === null || _h === void 0 ? void 0 : _h.failedResponse,
      },
      data: {
        giftId: this.giftId,
        giftlistId: giftListId,
      },
    });
    this.giftId = null;
  }
  async requestProductAvailabilityInfo() {
    var _a, _b, _c, _d;
    if ((_b = (_a = this.apcCta) === null || _a === void 0 ? void 0 : _a.urls) === null || _b === void 0 ? void 0 : _b.apcHost) {
      const requestUrl = availabilityUrl(this.apcCta.urls.apcHost, this.localeCode, this.productId);
      this.productAvailabilityInfo = await getAvailabilityInfo(requestUrl);
    }
    this.giftId = ((_d = (_c = this.productAvailabilityInfo) === null || _c === void 0 ? void 0 : _c.addToFavoritesInfo) === null || _d === void 0 ? void 0 : _d.giftId) || null;
  }
  getAPCDistributors() {
    var _a, _b, _c;
    const { BUY_ONLINE_BUTTON_REGULAR, BUY_ONLINE_BUTTON_APC } = ((_a = this.ctaArea) === null || _a === void 0 ? void 0 : _a.buttons) || {};
    if (BUY_ONLINE_BUTTON_REGULAR && BUY_ONLINE_BUTTON_APC) {
      const apcImgPath = getAssetPath('./public/images/apc_brand.gif');
      const stockLabel = (_c = (_b = this.ctaArea) === null || _b === void 0 ? void 0 : _b.labels) === null || _c === void 0 ? void 0 : _c.availableOnAPC;
      const apcUrl = BUY_ONLINE_BUTTON_APC.link;
      if (!stockLabel || !apcUrl) {
        return {};
      }
      return {
        [this.productId]: [getAPCDistributor(apcUrl, stockLabel, apcImgPath)],
      };
    }
    return {};
  }
  async componentDidLoad() {
    var _a;
    this.additionalDistributors = this.getAPCDistributors();
    if (!isBrowser()) {
      return;
    }
    await this.makeInitialRequests();
    this.storedProductsFeed = cloneDeep(this.productsFeed);
    if (isAnalyticsEnabled()) {
      send(viewItemGA4Event, gatherDataForViewItemAnalyticsEvent(this.productId, this.productInfo, this.ctaArea, this.productAvailabilityInfo, this.isApc()));
    }
    this.getParentWidth();
    this.setMediaGalleryStickiness();
    this.sdlHeaderResizeObserver = initSDLHeaderResizeObserver((entries) => {
      entries.forEach((entry) => {
        const { height } = entry.contentRect;
        if (this.headerHeight !== height) {
          this.headerHeight = height;
          this.setMediaGalleryStickinessPosition();
        }
      });
    });
    window.addEventListener('resize', this.handleResizeWindow);
    if (!this.isCircularProductEnabled
      || !this.circularProductRelationships
      || this.circularProductRelationships.length === 0)
      return;
    const promiseList = (_a = this.circularProductRelationships) === null || _a === void 0 ? void 0 : _a.map(({ productId }) => this.getLinkedCircularProductAvailableQuantityInStock(productId).then((quantity) => {
      this.circularProductsAvailableQuantity += quantity;
      this.isCircularProductAvailable || (this.isCircularProductAvailable = quantity > 0);
      if (quantity <= 0)
        return;
      this.availableCircularProducts[productId] = true;
    }));
    await Promise.all(promiseList);
    this.circularProductStockAvailabilityEvent.emit(this.availableCircularProducts);
    this.isStockAvailabilityChecked = true;
    if (!this.isCircularProductAvailable || !isAnalyticsEnabled()) {
      return;
    }
    const { pageTopCategory } = this.analyticsPageData || {};
    const ecommerceEventObject = getDataForEcommerceAnalyticsEvent({
      itemListName: pageTopCategory,
      isItemListNameAtEcommerceLevel: false,
      items: this.prepareItemsForGA(pageTopCategory),
    });
    send(viewItemListEvent, ecommerceEventObject);
  }
  async getLinkedCircularProductAvailableQuantityInStock(productId) {
    if (!this.isCircularProductEnabled || !this.circularEconomy) {
      return;
    }
    const { apiEndPointUrl: url, apiKey } = this.circularEconomy;
    const { error, result } = await ApigeeCircularStockAvailability.getCircularStockAvailability({
      url,
      apiKey,
      queryParams: {
        country: this.countryCode.toUpperCase(),
        productCommercialReference: productId,
      },
    });
    if (error) {
      console.error(`[PES]: Could not check stock availability information for ${productId}:\n${error.message}`);
      return 0;
    }
    return Number(result === null || result === void 0 ? void 0 : result.availableQuantity);
  }
  async onProductTabClickEvent(e) {
    var _a, _b;
    this.status = STATUS_TYPES.IDLE;
    if (this.activeProductTab === e.detail) {
      return;
    }
    if (this.getCircularProductData(e.detail) || e.detail === CircularProductTypes.LINEAR) {
      store.dispatch(setActiveProductTab(e.detail));
      return;
    }
    const circularProduct = this.circularProductRelationships.find((product) => product.circularType === e.detail);
    if (!circularProduct)
      return;
    await fetchProductData({
      productId: circularProduct.productId,
      localeCode: this.localeCode,
      circularType: e.detail,
      isPbs: this.isPBS,
    });
    const { error } = this.getState();
    if (error) {
      store.dispatch(setError(null));
      return;
    }
    store.dispatch(setActiveProductTab(e.detail));
    if (!isAnalyticsEnabled())
      return;
    const { pageTopCategory } = this.analyticsPageData || {};
    const items = this.prepareItemsForGA(pageTopCategory);
    const value = items.reduce((sum, item) => sum + Number(formatPrice(item.price)) * item.quantity, 0) || 'undefined';
    const ecommerceEventObject = {
      ecommerce: {
        currency: (_b = (_a = this.ctaArea) === null || _a === void 0 ? void 0 : _a.currency) !== null && _b !== void 0 ? _b : "EUR",
        item_list_name: pageTopCategory !== null && pageTopCategory !== void 0 ? pageTopCategory : '',
        value,
        items,
      },
    };
    send(selectItemCTAEvent, ecommerceEventObject);
  }
  disconnectedCallback() {
    var _a, _b;
    window.removeEventListener('resize', this.handleResizeWindow);
    (_a = this.sdlHeaderResizeObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
    if (isBrowser()) {
      this.mql.removeEventListener('change', this.breakpointListener);
    }
    (_b = this.unsubscribe) === null || _b === void 0 ? void 0 : _b.call(this);
  }
  async updateProductSelectorStatus() {
    this.showProductSelectorStatus = await this.requestProductSelectorStatus();
  }
  async requestProductSelectorStatus() {
    this.selectorConfig = merge({}, this.rangeSelectorConfig, this.productSelectorConfig);
    return setProductSelectorAvailability(this.selectorConfig, this.productSelectorConfig).then((state) => {
      return Object.assign(Object.assign({}, this.showProductSelectorStatus), { loaded: true, state });
    });
  }
  async makeInitialRequests() {
    this.loading = true;
    try {
      await allFinished([
        this.ccChainRequests(),
        this.requestSoftwareProducts(),
        this.updateProductSelectorStatus(),
      ]);
    }
    finally {
      this.loading = false;
    }
  }
  async ccChainRequests() {
    await this.requestCommerceConnectorSettings();
    await this.requestApcCta();
    await allFinished([
      this.requestMyProducts(),
      this.requestProductsFeed(),
      this.requestProductAvailabilityInfo(),
    ]);
  }
  async requestApcCta() {
    var _a, _b;
    const { apcCtaUrl } = (_b = (_a = this.commerceConnectorSettings) === null || _a === void 0 ? void 0 : _a.options) !== null && _b !== void 0 ? _b : {};
    if (this.isApc() && apcCtaUrl && !this.apcCta) {
      if (isV3()) {
        const localeArr = this.localeCode.split('/');
        const countryCode = localeArr[localeArr.length - 2];
        const languageCode = localeArr[localeArr.length - 1];
        const params = {
          countryCode,
          languageCode,
        };
        this.apcCta = await getApcCta(formCtaUrl(apcCtaUrl, params));
        return;
      }
      this.apcCta = await getApcCta(`${this.localeCode}${apcCtaUrl}`);
    }
  }
  async requestMyProducts() {
    var _a;
    if (this.isExternalConsumer && this.externaProductData) {
      this.isInMyProductsList = !!this.externaProductData.find((product) => product.productId === this.productId);
      return;
    }
    if (!(this.isApc() || isAppRoutingEnabled())) {
      const wishList = getSingleProductList((_a = (await getMyProductsFromConnector())) !== null && _a !== void 0 ? _a : []);
      this.isInMyProductsList = !!wishList.find((product) => product.productId === this.productId);
    }
  }
  async requestSoftwareProducts() {
    var _a, _b;
    if (!isEmpty(this.productSoftwareDocuments)) {
      this.softwareDocuments = this.prepareSoftwareDocuments(this.productSoftwareDocuments);
      return;
    }
    if ((_b = (_a = this.ctaArea) === null || _a === void 0 ? void 0 : _a.buttons) === null || _b === void 0 ? void 0 : _b.DOWNLOAD_BUTTON) {
      if (this.productSoftware) {
        this.softwareDocuments = this.productSoftware;
      }
      else {
        this.softwareDocuments = await getProductSoftware(this.localeCode, this.productId);
      }
      this.softwareDocuments = this.prepareSoftwareDocuments(this.softwareDocuments);
    }
  }
  async requestCommerceConnectorSettings() {
    if (!this.commerceConnectorSettings && this.localeCode) {
      this.commerceConnectorSettings = (await getCommerceConnectorSettings(this.localeCode))
        || null;
    }
  }
  async requestProductsFeed() {
    var _a, _b;
    const { feedUrl, circularFeedUrl, enableChannelSight, } = (_b = (_a = this.commerceConnectorSettings) === null || _a === void 0 ? void 0 : _a.options) !== null && _b !== void 0 ? _b : {};
    const adjustedFeedUrl = this.activeProductTab === CircularProductTypes.LINEAR
      ? feedUrl
      : circularFeedUrl;
    if (!this.productsFeed
      && enableChannelSight
      && adjustedFeedUrl
      && this.productId
      && !this.enableCommerceConnector) {
      this.productsFeed = await getProductsDataFeed({
        feedUrl: adjustedFeedUrl,
        productIds: this.productId,
      }) || null;
    }
  }
  get hasSlottedDiscountedPrice() {
    const slot = this.el.querySelector('slot[name=discounted-price]');
    return !!getSlottedContent(slot);
  }
  render() {
    const softwareInfo = softwareDocumentsToSoftwareInfo(this.softwareDocuments, this.labels);
    const isPesLinksAreaExist = (!isEmpty(this.links))
      || (!isEmpty(this.offlineStores))
      || !!this.priceSpiderInfo;
    const shouldAddToFavouritePopupBeVisible = !isAppRoutingEnabled()
      && this.isApc() && this.apcCta;
    return (h(ProductMainUI, { shouldAddToFavouritePopupBeVisible: Boolean(shouldAddToFavouritePopupBeVisible), displayLogInPopup: this.displayLogInPopup, productId: this.productId, productInfo: this.productInfo, onRangeLinkClick: isIndexDBEnabled() && this.onRangeLinkClick, productMedia: this.productMedia, handleSignInButtonDidClick: this.handleSignInButtonDidClick, handleCreateAccountButtonDidClick: this.handleCreateAccountButtonDidClick, handleAuthPopupClose: this.handleAuthPopupClose, apcCta: this.apcCta, ctaArea: this.ctaArea, commerceConnectorSettings: this.commerceConnectorSettings, productsFeed: this.productsFeed, productAvailabilityInfo: this.productAvailabilityInfo, getMyProductsRelatedProps: this.getMyProductsRelatedProps, isInFavorites: this.isInFavorites, labels: this.labels, links: this.links, ccBuyOnlineAvailability: this.ccBuyOnlineAvailability, softwareDocuments: this.softwareDocuments, selectorConfig: this.selectorConfig, showProductSelectorStatus: this.showProductSelectorStatus, shoppableRedirectionData: this.shoppableRedirectionData, productCR: this.productCR, localeCode: this.localeCode, masterRange: this.masterRange, isMediaGalleryFitsToViewport: this.isMediaGalleryFitsToViewport, productStatus: this.productStatus, highlightedCharacteristics: this.highlightedCharacteristics, gatherAdditionalInfo: this.gatherAdditionalInfo, variants: this.variants, substitutions: this.substitutions, bulletPoints: this.bulletPoints, sustainability: this.sustainability, alternatives: this.alternatives, renderPriceCtaContainer: this.renderPriceCtaContainer, offlineStores: this.offlineStores, priceSpiderInfo: this.priceSpiderInfo, softwareInfo: softwareInfo, bazaarVoiceInfo: this.bazaarVoiceInfo, isExternalConsumer: this.isExternalConsumer, prioritizeBuyNowButton: this.prioritizeBuyNowButton, softwareDocumentsDialogOpen: this.softwareDocumentsDialogOpen, handleDownloadModalClose: this.handleDownloadModalClose, showCompare: this.showCompare, parentWidth: this.parentWidth, externalUrlConfig: this.externalUrlConfig, isPesLinksAreaExist: Boolean(isPesLinksAreaExist), enableCommerceConnector: this.enableCommerceConnector, ccProductIdToShow: this.ccProductIdToShow, additionalDistributors: this.additionalDistributors, setMediaGalleryRef: this.setMediaGalleryRef, setProductContentRef: this.setProductContentRef, bulletPointsLimit: this.bulletPointsLimit, isCircularProductEnabled: this.isCircularProductEnabled, isCircularProductAvailable: this.isCircularProductAvailable, isStockAvailabilityChecked: this.isStockAvailabilityChecked, circularEconomy: this.circularEconomy, circularProductRelationships: this.isCircularProductEnabled ? this.circularProductRelationships : null, co2message: this.co2message, activeProductTab: this.activeProductTab, isCircularProductLoading: this.isCircularProductLoading, environmentalData: this.environmentalData, stickyBarRef: this.stickyBarRef, migration: this.migration, b2cRedirectionData: this.goToB2C, tags: this.tags, marketplacePdpUrl: this.marketplacePdpUrl, hasSlottedDiscountedPrice: this.hasSlottedDiscountedPrice }));
  }
  static get is() { return "pes-product-main"; }
  static get originalStyleUrls() {
    return {
      "$": ["product-main.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["product-main.css"]
    };
  }
  static get properties() {
    return {
      "productId": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "product-id",
        "reflect": false
      },
      "productCR": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "product-c-r",
        "reflect": false
      },
      "localeCode": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "locale-code",
        "reflect": false
      },
      "links": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "Record<string, TCtaButton>",
          "resolved": "{ [x: string]: TCtaButton; }",
          "references": {
            "Record": {
              "location": "global"
            },
            "TCtaButton": {
              "location": "import",
              "path": "../types"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "ctaArea": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TCtaData",
          "resolved": "{ currency?: string; price?: string; weeePrices?: WEEEPrices; buttons?: Partial<Record<ECtaButtonTypes, TCtaButton>>; labels?: { addedToCart: string; availableOnAPC?: string; }; ctas?: TCtaInfo[]; }",
          "references": {
            "TCtaData": {
              "location": "import",
              "path": "./types"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "shoppableRedirectionData": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TShopableRedirectionCtaData",
          "resolved": "{ shoppableRedirectionLabel: string; shoppableBuyButtonLabel: string; link: { shopableRedirectionHostUrl: string; shoppableRedirectionClickableLabel: string; }; }",
          "references": {
            "TShopableRedirectionCtaData": {
              "location": "import",
              "path": "./types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "masterRange": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TMasterRange",
          "resolved": "{ viewOnLabel: string; rangeName: string; rangeLink: string; }",
          "references": {
            "TMasterRange": {
              "location": "import",
              "path": "../links/range-link/types"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "productInfo": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TProductInfo",
          "resolved": "{ description?: string; badge?: TProductBadge; eNumberLabel?: string; eNumberCode?: string; brand?: string; }",
          "references": {
            "TProductInfo": {
              "location": "import",
              "path": "../main-product-info/types"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "highlightedCharacteristics": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "THighlightedCharacteristics",
          "resolved": "{ all: TLabelValues[]; }",
          "references": {
            "THighlightedCharacteristics": {
              "location": "import",
              "path": "../types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "offlineStores": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "OfflineStores",
          "resolved": "{ timeLabel?: string; time?: string; legalText?: string; findResellerLink?: FindResellerLink; }",
          "references": {
            "OfflineStores": {
              "location": "import",
              "path": "../pes-offline-stores/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "productStatus": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "ProductStatus",
          "resolved": "{ __typename?: \"ProductStatus\"; commercialColor?: string; commercialTextColor?: string; commercialMessage?: string; preCommercial?: boolean; preSale?: LifecycleInfoBlock; sale?: LifecycleInfoBlock; service?: LifecycleInfoBlock; title?: string; }",
          "references": {
            "ProductStatus": {
              "location": "import",
              "path": "../../../generated/graphql"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "variants": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TProductVariants | TOldProductVariants",
          "resolved": "[{ title: string; dropdown: boolean; variants: TOldProductVariant[]; }] | { chars: [{ title: string; charId: string; dropdown: boolean; variants: TProductVariant[]; }]; groupId: string; }",
          "references": {
            "TProductVariants": {
              "location": "import",
              "path": "../product-variants/types"
            },
            "TOldProductVariants": {
              "location": "import",
              "path": "../product-variants/types"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "rangeSelectorConfig": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TScProductSelectorConfig",
          "resolved": "{ type: \"sc\"; scConfiguratorUrlJS: string; scConfiguratorUrlCSS: string; scLanguage: string; scCountry: string; scToken: string; scProject: string; scDataset: string; scOptions: Record<string, unknown>; scFunctionalIds: string; scLabel: string; }",
          "references": {
            "TScProductSelectorConfig": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "productSelectorConfig": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "THpcProductSelectorConfig",
          "resolved": "{ productCR: string; country?: string; language?: string; project?: string; token?: string; scUrl: string; enableCrossTechAPI: boolean; enableProductSelectorButton?: boolean; options: Record<string, unknown>; buttonlabel: string; type: \"hpc\" | \"cr\"; enableNewWidget?: boolean; personalizeProductLabel?: string; customizeProductLabel?: string; customizeHereLinkLabel?: string; }",
          "references": {
            "THpcProductSelectorConfig": {
              "location": "import",
              "path": "../../UI/product-selector/hpc-product-selector/hpc-product-selector"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "substitutions": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "SubstitutionInfo",
          "resolved": "{ __typename?: \"SubstitutionInfo\"; productSimpleLabel?: string; productSubstitutionDateLabel?: string; productSubstitutionReasonLabel?: string; qtyLabel?: string; viewAllLabel?: string; substitutions?: Substitution[]; title?: string; recommendedReplacementsLabel?: string; viewMoreLabel?: string; viewLessLabel?: string; addToMyProductsLabel?: string; removeFromMyProductsLabel?: string; addGroupToMyProductsLabel?: string; removeGroupFromMyProductsLabel?: string; productsNumberLabel?: string; substitutionAbsentLabel?: string; orLabel?: string; cartTransferEnabled?: boolean; }",
          "references": {
            "SubstitutionInfo": {
              "location": "import",
              "path": "../../../generated/graphql"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "alternatives": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "Alternatives",
          "resolved": "AlternativesInfo & { addToMyProductsLabel?: string; removeFromMyProductsLabel?: string; recommendedReplacementsLabel?: string; title?: string; alternativeAbsentLabel?: string; cartTransferEnabled?: boolean; viewMoreLabel?: string; viewLessLabel?: string; ctaInfo?: TCtaInfo; }",
          "references": {
            "Alternatives": {
              "location": "import",
              "path": "../../../generated/graphql"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "materialPriceGroup": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TMaterialPriceGroup",
          "resolved": "{ price: string; label: string; }",
          "references": {
            "TMaterialPriceGroup": {
              "location": "import",
              "path": "../cta-area-se-container/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "productSoftware": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TProductSoftwareDocument[]",
          "resolved": "TProductSoftwareDocument[]",
          "references": {
            "TProductSoftwareDocument": {
              "location": "import",
              "path": "../../../globals/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "labels": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "Record<string, string>",
          "resolved": "{ [x: string]: string; }",
          "references": {
            "Record": {
              "location": "global"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "commerceConnectorSettings": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "CommerceConnectorSettings | null",
          "resolved": "{ options: CommerceConnectorOptions; labels: CommerceConnectorLabels; messages: CommerceConnectorMessages; }",
          "references": {
            "CommerceConnectorSettings": {
              "location": "import",
              "path": "../../commerce-connector/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "defaultValue": "null"
      },
      "productsFeed": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "ProductsFeed | null",
          "resolved": "FeedProduct[]",
          "references": {
            "ProductsFeed": {
              "location": "import",
              "path": "../../commerce-connector/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "defaultValue": "null"
      },
      "bulletPoints": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TBulletPointItem[] | null",
          "resolved": "TBulletPointItem[]",
          "references": {
            "TBulletPointItem": {
              "location": "import",
              "path": "../bullet-points/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "defaultValue": "null"
      },
      "bulletPointsLimit": {
        "type": "number",
        "mutable": true,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "bullet-points-limit",
        "reflect": false,
        "defaultValue": "0"
      },
      "sustainability": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TSustainabilityItem | null",
          "resolved": "{ greenPremiumLogo?: TGreenPremiumLogo; energyStarLogo?: TEnergyStarLogo; sustainabilityLabel?: string; seeAllLabel?: string; closeLabel?: string; sustainabilityPillar?: TSustainabilityPillar[]; }",
          "references": {
            "TSustainabilityItem": {
              "location": "import",
              "path": "../sustainability-overview/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "defaultValue": "null"
      },
      "prioritizeBuyNowButton": {
        "type": "boolean",
        "mutable": true,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "prioritize-buy-now-button",
        "reflect": false,
        "defaultValue": "false"
      },
      "environmentalData": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TEnvironmentalTopBlock",
          "resolved": "{ viewFullEnvironmentalData: string; data: TEnvironmentalTopBlockDataInfo; }",
          "references": {
            "TEnvironmentalTopBlock": {
              "location": "import",
              "path": "../../product/environmental-top-block/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "circularEconomyInfo": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "CircularEconomy",
          "resolved": "{ circularCertifiedLogo?: string; message?: string; apiEndPointUrl?: string; toolTipMessage?: string; toolTipLearnMoreLabel?: string; toolTipLearnMoreUrl?: string; apiKey?: string; enableCircularProducts?: boolean; enableCircularProductNewBadge?: boolean; }",
          "references": {
            "CircularEconomy": {
              "location": "import",
              "path": "../../circular-economy/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "co2message": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "co-2message",
        "reflect": false
      },
      "circularEconomy": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "CircularEconomyNew",
          "resolved": "{ apiEndPointUrl: string; apiKey?: string; circularNatureLabels: Record<CircularProductTypes, string>; stockQuantityLabel?: string; newBadge: boolean; newBadgeLabel?: string; }",
          "references": {
            "CircularEconomyNew": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "circularProductRelationships": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "CircularProductRelationships",
          "resolved": "CircularProductRelationship[]",
          "references": {
            "CircularProductRelationships": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "circularProductMainCards": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "ProductsApi.Product[]",
          "resolved": "Product[]",
          "references": {
            "ProductsApi": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "productSoftwareDocuments": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TProductSoftwareDocument[]",
          "resolved": "TProductSoftwareDocument[]",
          "references": {
            "TProductSoftwareDocument": {
              "location": "import",
              "path": "../../../globals/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "goToB2C": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "B2CRedirectionData",
          "resolved": "{ label: string; cta: { label: string; type?: string; url: string; }; }",
          "references": {
            "B2CRedirectionData": {
              "location": "import",
              "path": "./types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "tags": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "PesTagsData",
          "resolved": "{ [key: string]: { label: string; }; }",
          "references": {
            "PesTagsData": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "isPBS": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines whether the component is integrated to PBS."
        },
        "attribute": "is-p-b-s",
        "reflect": false
      },
      "isExternalConsumer": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Defines consumer is external-user"
        },
        "attribute": "is-external-consumer",
        "reflect": false
      },
      "externalUrlConfig": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TExternalUrlConfig",
          "resolved": "{ viewDetail: string[]; substitution: string[]; }",
          "references": {
            "TExternalUrlConfig": {
              "location": "import",
              "path": "../../../globals/external-consumer"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Defines customized url(s) of hyperlink for external-user"
        }
      },
      "externaProductData": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TMyProduct[]",
          "resolved": "TMyProduct[]",
          "references": {
            "TMyProduct": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Defines list of my-products for external-user"
        }
      },
      "_bulletPoints": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-bullet-points",
        "reflect": false
      },
      "_bulletPointsLimit": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-bullet-points-limit",
        "reflect": false
      },
      "_sustainability": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-sustainability",
        "reflect": false
      },
      "_productId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-product-id",
        "reflect": false
      },
      "_productCR": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-product-cr",
        "reflect": false
      },
      "_localeCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-locale-code",
        "reflect": false
      },
      "_links": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-links",
        "reflect": false
      },
      "_ctaArea": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-cta-area",
        "reflect": false
      },
      "_shoppableRedirectionData": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-product-shoppable-redirection",
        "reflect": false
      },
      "_masterRange": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-master-range",
        "reflect": false
      },
      "_productInfo": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-product-info",
        "reflect": false
      },
      "_highlightedCharacteristics": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-highlighted-characteristics",
        "reflect": false
      },
      "_offlineStores": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-offline-stores",
        "reflect": false
      },
      "_productStatus": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-product-status",
        "reflect": false
      },
      "_variants": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-variants",
        "reflect": false
      },
      "_rangeSelectorConfig": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-range-selector-config",
        "reflect": false
      },
      "_productSelectorConfig": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-product-selector-config",
        "reflect": false
      },
      "_substitutions": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-substitutions",
        "reflect": false
      },
      "_commerceConnectorSettings": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-commerce-connector-settings",
        "reflect": false
      },
      "_materialPriceGroup": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-material-price-group",
        "reflect": false
      },
      "_productSoftware": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-product-software",
        "reflect": false
      },
      "_productsFeed": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-products-feed",
        "reflect": false
      },
      "_labels": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-labels",
        "reflect": false
      },
      "_alternatives": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-alternatives",
        "reflect": false
      },
      "_prioritizeBuyNowButton": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-prioritize-buy-now-button",
        "reflect": false
      },
      "_externalUrlConfig": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-external-url-config",
        "reflect": false
      },
      "_externaProductData": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-external-product-data",
        "reflect": false
      },
      "_environmentalData": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-environmental-data",
        "reflect": false
      },
      "_co2message": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-co2message",
        "reflect": false
      },
      "_circularEconomyInfo": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-circular-economy-info",
        "reflect": false
      },
      "_circularEconomy": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-circular-economy",
        "reflect": false
      },
      "_circularProductRelationships": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-circular-product-relationships",
        "reflect": false
      },
      "_circularProductMainCards": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-circular-product-main-cards",
        "reflect": false
      },
      "_productSoftwareDocuments": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-software-documents",
        "reflect": false
      },
      "showCompare": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Configures if compare control is shown"
        },
        "attribute": "show-compare",
        "reflect": false,
        "defaultValue": "true"
      },
      "enableCommerceConnector": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "enable-commerce-connector",
        "reflect": false,
        "defaultValue": "true"
      },
      "showBuyOnline": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines whether to show Buy Online button"
        },
        "attribute": "show-buy-online",
        "reflect": false,
        "defaultValue": "true"
      },
      "productMedia": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "ProductMedia",
          "resolved": "{ __typename?: \"ProductMedia\"; dblTapImgLabel?: string; expandImgLabel?: string; image360?: Image360; imgLabel?: string; nodeName?: string; pdpDragToRotateLabel?: string; pdpImage360Label?: string; pdpTapToViewLabel?: string; rollOverImgLabel?: string; videoLabel?: string; videos?: ProductVideoLink[]; gallery?: Gallery; zoomPictureDesktop?: ImageLink; zoomPictureMobile?: ImageLink; zoomPicturePreview?: ImageLink; zoomPictureThumbnail?: ImageLink; alternativeImages?: AlternativeImage[]; productStatus?: ProductStatus; greenPremiumLogo?: LogoInfo; pdsLogo?: LogoInfo; energyStarLogo?: LogoInfo; extraBadges?: ExtraBadges[]; ctaMainImage?: MediaGalleryClickEventParamsType; }",
          "references": {
            "ProductMedia": {
              "location": "import",
              "path": "../../../generated/graphql"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "host": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Host url without lang and country codes"
        },
        "attribute": "host",
        "reflect": false
      },
      "languageCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": ": en"
            }],
          "text": "languageCode"
        },
        "attribute": "language-code",
        "reflect": false
      },
      "migration": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "migration",
        "reflect": false
      },
      "stickyBarRef": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "HTMLElement",
          "resolved": "HTMLElement",
          "references": {
            "HTMLElement": {
              "location": "global"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "_showCompare": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-show-compare",
        "reflect": false
      },
      "_enableCommerceConnector": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-enable-commerce-connector",
        "reflect": false
      },
      "_productMedia": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-product-media",
        "reflect": false
      },
      "priceSpiderInfo": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "PriceSpiderInfo",
          "resolved": "{ ourPartnersLabel: string; showAllLabel: string; modalTitle: string; availableWidgets: Record<string, string>; checkDistributor?: ExtendedHtmlLink; }",
          "references": {
            "PriceSpiderInfo": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "bazaarVoiceInfo": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TBazaarVoiceInfo",
          "resolved": "{ enabled: boolean; scriptUrl: string; }",
          "references": {
            "TBazaarVoiceInfo": {
              "location": "import",
              "path": "../bazaar-voice-rating/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "_priceSpiderInfo": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-price-spider-info",
        "reflect": false
      },
      "_bazaarVoiceInfo": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-bazaar-voice-info",
        "reflect": false
      },
      "marketplacePdpUrl": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-marketplace-pdp-url",
        "reflect": false
      },
      "_goToB2C": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-go-to-b2c",
        "reflect": false
      },
      "_tags": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-tags",
        "reflect": false
      },
      "countryCode": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "country-code",
        "reflect": false
      },
      "apcCta": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TApcCta",
          "resolved": "{ urls: { apcHost: string; }; labels: { addToCartButtonLabel: string; vatLabel: string; inStockLabel: string; authToAddToFavorites: string; removeFromFavorites: string; addToFavorites: string; favorites: string; itemAddedTo: string; signIn: string; createAccount: string; itemRemovedFrom: string; failedResponse: string; }; }",
          "references": {
            "TApcCta": {
              "location": "import",
              "path": "../../../globals/apc-cta/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "defaultValue": "null"
      },
      "productAvailabilityInfo": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TProductAvailabilityInfo",
          "resolved": "{ howToBuyShowing: { [productId: string]: boolean; }; addToFavoritesInfo: TAddToFavoritesInfo; prices: TPrices; substitution: TSubstitution; factoryStore: TFactoryStore; availability: TAvailability; }",
          "references": {
            "TProductAvailabilityInfo": {
              "location": "import",
              "path": "../../../globals/apc-cta/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "defaultValue": "null"
      },
      "_apcCta": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-apc-cta",
        "reflect": false
      },
      "_productAvailabilityInfo": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-product-availability-info",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "showProductSelectorStatus": {},
      "loading": {},
      "ccProductIdToShow": {},
      "ccBuyOnlineAvailability": {},
      "parentWidth": {},
      "softwareDocuments": {},
      "softwareDocumentsDialogOpen": {},
      "isInMyProductsList": {},
      "favoritesButtonDisabled": {},
      "isMediaGalleryFitsToViewport": {},
      "status": {},
      "activeProductTab": {},
      "additionalDistributors": {},
      "displayLogInPopup": {},
      "giftId": {},
      "shopSeLink": {},
      "showShopSeLoader": {},
      "selectorConfig": {},
      "isCircularProductEnabled": {},
      "isCircularProductAvailable": {},
      "isStockAvailabilityChecked": {},
      "availableCircularProducts": {},
      "analyticsPageData": {},
      "isCircularProductLoading": {},
      "stockQuantityLabel": {},
      "isMobile": {},
      "circularProductsAvailableQuantity": {},
      "storedProductsFeed": {}
    };
  }
  static get events() {
    return [{
        "method": "ctaClick",
        "name": "ctaClick",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "TCtaClick",
          "resolved": "{ id?: string; type: string; initialEvent: MouseEvent; product: TMyProductsAddParams; inList?: boolean; onFinish?: (result?: TMyProductsAddResponse | TMyProductsRemoveResponse) => any; bannerContext?: \"body\" | \"header\"; }",
          "references": {
            "TCtaClick": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        }
      }, {
        "method": "circularProductStockAvailabilityEvent",
        "name": "circularProductStockAvailabilityEvent",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "Record<string, boolean>",
          "resolved": "{ [x: string]: boolean; }",
          "references": {
            "Record": {
              "location": "global"
            }
          }
        }
      }];
  }
  static get elementRef() { return "el"; }
  static get listeners() {
    return [{
        "name": "apcCtaButtonDidClick",
        "method": "onApcCtaButtonDidClick",
        "target": "document",
        "capture": false,
        "passive": false
      }, {
        "name": "notifyButtonDidClick",
        "method": "onNotifyClick",
        "target": "document",
        "capture": false,
        "passive": false
      }, {
        "name": "promotedButtonDidClick",
        "method": "onPromotedClick",
        "target": "document",
        "capture": false,
        "passive": false
      }, {
        "name": "buyOnlineClick",
        "method": "onProductBuyOnlineClick",
        "target": "document",
        "capture": false,
        "passive": false
      }, {
        "name": "ccBtnBuyOnlineAvailability",
        "method": "onCCBtnBuyOnlineAvailability",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "channelSightResponse",
        "method": "onChannelSightResponse",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "ccDialogClosed",
        "method": "onCCDialogClosed",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "ccBroadcastPrices",
        "method": "onCCPricesReceived",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "addToMyProductsButtonDidClick",
        "method": "handleAddToMyProductsButtonClick",
        "target": "document",
        "capture": false,
        "passive": false
      }, {
        "name": "addToCartButtonDidClick",
        "method": "handleAddToCartButtonClick",
        "target": "document",
        "capture": false,
        "passive": false
      }, {
        "name": "downloadButtonDidClick",
        "method": "handleDownloadButtonDidClick",
        "target": "document",
        "capture": false,
        "passive": false
      }, {
        "name": "marketplaceDidClick",
        "method": "onMarketplaceDidClick",
        "target": "document",
        "capture": false,
        "passive": false
      }, {
        "name": "productTabClickEvent",
        "method": "onProductTabClickEvent",
        "target": "document",
        "capture": false,
        "passive": false
      }];
  }
}
